import { Link } from 'react-router-dom';
import { CalendarPlus, Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';

// Seção final da Home: dois CTAs (organizador / app) dividindo o mesmo
// fundo — um único conjunto de blobs cobrindo a seção toda, sem quebra de
// cor entre as colunas. No mobile empilha (organizador em cima, app
// embaixo); no desktop fica lado a lado com um divisor sutil entre elas.
export function OrganizerCTA() {
  return (
    <section className="py-24 bg-gradient-to-br from-slate-900 via-zinc-900 to-slate-800 relative overflow-hidden">
      <div className="absolute -top-24 right-0 w-96 h-96 rounded-full bg-violet-600/10 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-24 left-0 w-96 h-96 rounded-full bg-orange-500/10 blur-3xl pointer-events-none" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 rounded-full bg-[#14a0a0]/10 blur-3xl pointer-events-none" />

      <div className="relative z-10 max-w-[1920px] mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">

          {/* Coluna esquerda — organizadores */}
          <div className="flex flex-col items-center text-center lg:pr-16">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-white/10 backdrop-blur-sm mb-6">
              <CalendarPlus className="w-8 h-8 text-white" />
            </div>

            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 tracking-tight">
              Você organiza eventos?
            </h2>
            <p className="text-lg text-slate-400 mb-10 leading-relaxed max-w-xl">
              Publique gratuitamente e alcance quem realmente quer participar.
              Impulsione seu evento para aparecer em destaque na plataforma.
            </p>

            <Button
              asChild
              size="lg"
              className="rounded-full px-8 bg-white text-slate-900 hover:bg-slate-100 transition-colors"
            >
              <Link to="/login">Divulgar meu evento</Link>
            </Button>
          </div>

          {/* Divisor sutil só no desktop + Coluna direita — baixar o app.
              Mesmo padrão de espaçamento (mb-6 / mb-4 / mb-10), tamanho de
              ícone/título/texto e alinhamento centralizado da coluna
              esquerda, pra ficarem com o mesmo peso visual lado a lado. */}
          <div className="flex flex-col items-center text-center lg:pl-16 lg:border-l lg:border-white/10">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-white/10 backdrop-blur-sm mb-6">
              <Sparkles className="w-8 h-8 text-white" />
            </div>

            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 tracking-tight max-w-md">
              Joyn também cabe no seu bolso.
            </h2>

            <p className="text-lg text-slate-400 mb-10 leading-relaxed max-w-md">
              Descubra eventos, salve favoritos e receba notificações — tudo direto no app.
            </p>

            {/* Badges oficiais das lojas — ambos apontam para /baixar/, a
                smart-redirect que já detecta iOS/Android sozinha.
                Mesma altura pros dois (padrão oficial Apple/Google de
                badges lado a lado); a largura de cada um segue livre a
                partir do aspect ratio nativo do próprio arquivo. */}
            <div className="flex flex-wrap items-center justify-center gap-4">
              <a href="/baixar/" aria-label="Disponível no Google Play" className="shrink-0">
                <img
                  src="/badges/google-play-badge.png"
                  alt="Disponível no Google Play"
                  className="h-14 sm:h-16 w-auto"
                />
              </a>
              <a href="/baixar/" aria-label="Baixar na App Store" className="shrink-0">
                <img
                  src="/badges/app-store-badge.svg"
                  alt="Baixar na App Store"
                  className="h-14 sm:h-16 w-auto"
                />
              </a>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
